import React, { useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import SimpleApiExplorer from '../components/SimpleApiExplorer';
import './PageStyles.css';

const EDDRules = () => {
  const [showTryApi, setShowTryApi] = useState(false);
  const eddRules = [
    { id: 1, name: 'High Value Transaction', threshold: '$10,000', description: 'Enhanced due diligence for transactions above $10,000', status: 'Active', priority: 1 },
    { id: 2, name: 'Frequent Transactions', threshold: '5 per day', description: 'EDD for customers with more than 5 transactions per day', status: 'Active', priority: 2 },
    { id: 3, name: 'New Customer', threshold: 'First transaction', description: 'EDD for first-time customers', status: 'Active', priority: 3 },
    { id: 4, name: 'High-Risk Country', threshold: 'N/A', description: 'EDD for transactions to high-risk countries', status: 'Active', priority: 4 },
  ];

  const sampleRequest = {
    name: "Large Amount Transaction",
    threshold: "$50,000",
    description: "Enhanced due diligence for transactions above $50,000",
    status: "active",
    priority: 1,
    required_documents: ["id_proof", "address_proof", "source_of_funds"]
  };

  const sampleResponse = {
    status: "success",
    code: "200",
    message: "EDD rule created successfully",
    data: {
      id: 5,
      name: "Large Amount Transaction",
      threshold: "$50,000",
      description: "Enhanced due diligence for transactions above $50,000",
      status: "active",
      priority: 1,
      required_documents: ["id_proof", "address_proof", "source_of_funds"],
      created_at: "2024-01-15T10:30:00Z"
    },
    request_id: "req_123456789"
  };

  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="card">
          <div className="card-header card-header-master">
            <h2>EDD Rules</h2>
            <button type="button" className="btn btn-secondary" onClick={() => setShowTryApi(true)}>
              Try API
            </button>
          </div>
          
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Threshold</th>
                <th>Description</th>
                <th>Priority</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {eddRules.map((rule) => (
                <tr key={rule.id}>
                  <td>{rule.id}</td>
                  <td><strong>{rule.name}</strong></td>
                  <td>{rule.threshold}</td>
                  <td>{rule.description}</td>
                  <td>{rule.priority}</td>
                  <td>
                    <span className={`status-badge ${rule.status.toLowerCase()}`}>
                      {rule.status}
                    </span>
                  </td>
                  <td>
                    <button className="btn btn-secondary btn-sm">Edit</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {showTryApi && <div className="try-api-sidebar-overlay" onClick={() => setShowTryApi(false)} aria-hidden="true" />}
        {showTryApi && (
          <aside className="try-api-sidebar">
            <SimpleApiExplorer
              apiName="EDD Rules API"
              endpoint="/api/v1/edd-rules"
              method="POST"
              sampleRequest={sampleRequest}
              sampleResponse={sampleResponse}
              onClose={() => setShowTryApi(false)}
            />
          </aside>
        )}
      </div>
    </DashboardLayout>
  );
};

export default EDDRules;
